import React from "react";
import { useTranslation } from "react-i18next";
import { Pressable, Text, View } from "react-native";
import { ActivityIndicator } from "react-native-paper";

type Props = Readonly<{
  count: number;
  loading?: boolean;
  onPress: () => void;
}>;

/**
 * "N new posts": floats over the top of the feed while newer posts are held
 * back so the reader's place does not move. Tapping it shows them and scrolls
 * up; nothing jumps on its own.
 */
export default function NewPostsPill({ count, loading, onPress }: Props) {
  const { t } = useTranslation();
  const label =
    count === 1
      ? t("LABEL_NEW_POST_SINGLE")
      : t("LABEL_NEW_POSTS_COUNT", { count });
  return (
    <View
      pointerEvents="box-none"
      className="absolute left-0 right-0 top-2 z-10 items-center"
    >
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={label}
        testID="new-posts-pill"
        disabled={loading}
        onPress={onPress}
        className="flex-row items-center gap-2 rounded-full bg-primary px-4 py-2 shadow-md"
      >
        {loading ? <ActivityIndicator size={12} color="white" /> : null}
        <Text className="text-sm font-semibold text-white">↑ {label}</Text>
      </Pressable>
    </View>
  );
}
